import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'

import { updateFormDataField } from 'cng-common/features/form'

import { getKeyInitiativeProgramType } from '../../lib/getKeyInitiativeProgramType'

interface IUseKeyInitiativeProgramType {
  formKey: string
  keyObjective?: string
  keyObjectives: IKeyObjective[]
  programType: ProgramTypes
  currentProgramType?: string | null
}

/** Keep the initiative's offering separate from the editor's dictionary/financial context. */
export const useKeyInitiativeProgramType = ({
  formKey,
  keyObjective,
  keyObjectives,
  programType,
  currentProgramType,
}: IUseKeyInitiativeProgramType) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Do not infer an offering while the selected SI's settings are still unavailable.
    if (!keyObjective || !keyObjectives.some((objective) => objective.key === keyObjective)) return

    const nextProgramType = getKeyInitiativeProgramType(keyObjective, keyObjectives, programType)
    if (currentProgramType === nextProgramType) return

    dispatch(
      updateFormDataField({
        formKey,
        field: 'programType',
        value: nextProgramType,
        // A derived field must not activate validation on a pristine creation form.
        ignoreModified: true,
      })
    )
  }, [dispatch, formKey, keyObjective, keyObjectives, programType, currentProgramType])
}
